// extracted by mini-css-extract-plugin
export var back = "CourseCard-module--back--9975b";
export var backContent = "CourseCard-module--backContent--61012";
export var blueChip = "CourseCard-module--blueChip--15625";
export var cardOne = "CourseCard-module--cardOne--b01ab";
export var center = "CourseCard-module--center--c4704";
export var chip = "CourseCard-module--chip--63af2";
export var chipBig = "CourseCard-module--chipBig--ce7f2";
export var flexCard = "CourseCard-module--flexCard--0db61";
export var front = "CourseCard-module--front--2d831";
export var icon = "CourseCard-module--icon--c22dd";
export var texts = "CourseCard-module--texts--c0405";
export var yellowChip = "CourseCard-module--yellowChip--13b94";